/* eslint-disable no-console */
/* eslint-disable no-underscore-dangle */
/* eslint-disable no-param-reassign */
import axios from 'axios';
import { clearUser, refreshToken, signin } from './oidcClient';

const api = axios.create({
  baseURL: process.env.REACT_APP_EMERGYA_SERVER_API_HOST,
});

/**
 * Go to login if the token has expired or go to error permisos if the user has not permission
 * @param error
 */
async function handleSession(error: any): Promise<void> {
  if (error?.response?.status === 401 || error?.response?.data?.status === 401) {
    await clearUser();
    await signin();
  } else if (error?.response?.data?.status === 403) {
    window.location.href = '/error-permisos';
  }
}

// Add a request interceptor
api.interceptors.request.use(
  async (config) => {
    const token = await refreshToken();
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
      config.headers['Content-Type'] = 'application/json';
    }
    return config;
  },
  (error: any) => Promise.reject(error),
);

// Add a response interceptor
api.interceptors.response.use(
  (response: any) => response,
  async (err) => {
    const originalRequest = err.config;
    let error = err;
    // If the error response is a Blob, we need to parse it to JSON. Case export to excel
    if (err.response?.data instanceof Blob) {
      error = await new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = () => {
          try {
            const result = JSON.parse(reader.result as string);
            resolve({ response: { status: result.status, data: result } });
          } catch (e) {
            resolve(reader.result);
          }
        };
        reader.onerror = reject;
        reader.readAsText(err.response.data);
      });
    }
    // If the error status is 401 and there is no originalRequest._retry flag,
    // it means the token has expired and we need to refresh it
    if (error.response?.status === 401 && originalRequest && !originalRequest._retry) {
      originalRequest._retry = true;
      try {
        const refreshedToken = await refreshToken();
        if (!refreshedToken) {
          await handleSession(error);
          return Promise.reject(error);
        }
        return api(originalRequest);
      } catch (errorRefresh) {
        console.log(errorRefresh);
        await handleSession(error);
      }
    } else {
      console.log(error);
      await handleSession(error);
    }
    return Promise.reject(error);
  },
);

export default api;
